/**
 * IB Web Common: Window Properties
 */


let keyName = {
    3: 'Cancel',
    6: 'Help',
    8: 'Backspace',
    9: 'Tab',
    12: 'Clear',
    13: 'Enter',
    16: 'Shift',
    17: 'Control',
    18: 'Alt',
    19: 'Pause',
    20: 'CapsLock',
    27: 'Escape',
    28: 'Convert',
    29: 'NonConvert',
    30: 'Accept',
    31: 'ModeChange',
    32: ' ',
    33: 'PageUp',
    34: 'PageDown',
    35: 'End',
    36: 'Home',
    37: 'ArrowLeft',
    38: 'ArrowUp',
    39: 'ArrowRight',
    40: 'ArrowDown',
    41: 'Select',
    42: 'Print',
    43: 'Execute',
    44: 'PrintScreen',
    45: 'Insert',
    46: 'Delete',
    48: ['0', ')'],
    49: ['1', '!'],
    50: ['2', '@'],
    51: ['3', '#'],
    52: ['4', '$'],
    53: ['5', '%'],
    54: ['6', '^'],
    55: ['7', '&'],
    56: ['8', '*'],
    57: ['9', '('],
    93: 'ContextMenu',
    144: 'NumLock',
    145: 'ScrollLock',
    181: 'VolumeMute',
    182: 'VolumeDown',
    183: 'VolumeUp',
    186: [';', ':'],
    187: ['=', '+'],
    188: [',', '<'],
    189: ['-', '_'],
    190: ['.', '>'],
    191: ['/', '?'],
    192: ['`', '~'],
    219: ['[', '{'],
    220: ['\\', '|'],
    221: [']', '}'],
    222: ["'", '"'],
    224: 'Meta',
    250: 'Play',
    251: 'ZoomOut'
};

// IE and Edge implement an obsolete version of the KeyboardEvent spec
let keyFix = {
    'Escape': 'Esc',
    'Delete': 'Del',
    'ArrowLeft': 'Left',
    'ArrowUp': 'Up',
    'ArrowRight': 'Right',
    'ArrowDown': 'Down'
};

for (let i = 1; i < 25; i++) {
    keyName[111 + i] = 'F' + i;
}

for (let i = 65; i < 91; i++) {
    const letter = String.fromCharCode(i);
    keyName[i] = [letter.toLowerCase(), letter.toUpperCase()];
}

const keyCmd = /^Mac/.test(navigator.platform);

let keyBound = {};


const isVisible = el => {

    const parent = el.offsetParent;
    if (parent == null) {
        return false;
    }
    if (parent === document.body) { // Maybe IE
        do {
            const style = getComputedStyle(el);
            if (style.display == 'none') {
                return false;
            }
        } while((el = el.parentNode));
    }
    return true;
}


function keyBindCb(e) {

    let key = e.key || keyName[e.which || e.keyCode];
    if (Array.isArray(key)) {
        key = key[+e.shiftKey];
    }

    let bind;
    if (keyCmd) {
        bind = keyBound[
            (e.metaKey ? 'Cmd+' : '') +
            (e.ctrlKey ? 'Ctrl+' : '') + key];
    } else {
        bind = e.ctrlKey
            ? (keyBound['Cmd+' + key] || keyBound['Ctrl+' + key])
            : (keyBound[key]);
    }

    if (bind) {
        for (let i = 0; i < bind.length; i++) {
            if (typeof bind[i] === 'function') {
                bind[i](e);
                e.stopPropagation();
                e.preventDefault();
                return;
            }
        }
        for (let i = 0; i < bind.length; i++) {
            if (bind[i].nodeType && isVisible(bind[i])) {
                bind[i].click(e);
                e.stopPropagation();
                e.preventDefault();
                return;
            }
        }
    }
}


/** Bind key to click event on an element */

export const bindKey = (key, node) => {

    if (keyBound[key] === void 0) {
        keyBound[key] = [node];
    } else {
        keyBound[key].push(node);
    }
    if (keyFix[key]) {
        bindKey(keyFix[key], node);
    }
    addEventListener('keydown', keyBindCb);
}


/** Unbind a key from click event on an element */

export const unbindKey = (key, node) => {

    if (keyFix[key]) {
        unbindKey(keyFix[key], node);
    }
    if (keyBound[key] !== void 0) {
        keyBound[key] = keyBound[key].filter((e) => (e != node));
    }
}
